var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.compact ? 'filepond-compact-root' : 'filepond-default-root'},[_c('file-pond',{ref:"pond",attrs:{"name":"file","label-idle":_vm.pondLabelIdle,"allow-multiple":_vm.multiple,"accepted-file-types":_vm.acceptedTypes,"server":_vm.serverOptions},on:{"init":_vm.handleFilePondInit,"processfile":_vm.handleProcessFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }